import { render, staticRenderFns } from "./SepaColumnManagement.vue?vue&type=template&id=16ab8596&scoped=true&"
import script from "./SepaColumnManagement.vue?vue&type=script&lang=js&"
export * from "./SepaColumnManagement.vue?vue&type=script&lang=js&"
import style0 from "./SepaColumnManagement.vue?vue&type=style&index=0&id=16ab8596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ab8596",
  null
  
)

export default component.exports